import { Col, Form, Input, message, Row } from "antd";
import React, { useRef, useState } from "react";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import styled from "styled-components";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CALL_API } from "common/API";
import { connect, useSelector } from "react-redux";
import { getClientid, getMenuList, getUserInfo, getUserRoleId } from "redux/selectors";
import { STATUS_CODE } from "common/Constants";
import { bindActionCreators } from "redux";
import { setMenuList, setRoleList, setUserList } from "redux/actions";
import SuccessPopup from "./SuccessPopup";

const EditRoleWrapp = styled.div`
  position: relative;
  height: calc(100vh - 150px);
`;

const EditRole = ({
  roleList,
  details,
  setIsEditRole,
  getRoleList,
  saveRoleList,
  updateUserList,
  saveMenuList,
}) => {
  const allMenuList = useSelector(getMenuList);
  const clientId = useSelector(getClientid);
  const userInfo = useSelector(getUserInfo);
  const [form] = Form.useForm();
  const containerRef = useRef();
  const [loader, setLoader] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const roleId = useSelector(getUserRoleId);
  const [successMessage, setSuccessMessage] = useState("");
  const menuList = Array.isArray(allMenuList[roleId])
    ? allMenuList[roleId].filter((item) => item?.system === "hr")
    : [];
  const fetchMasterData = async (fetch_master_data, menuList, userrole) => {
    const { code, roleList, userList } = await CALL_API(
      `master-data/${clientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      if (fetch_master_data) {
        if (userrole === "Owner") {
          saveMenuList({[roleId]: menuList });
        } else {
          saveMenuList(
            userList?.find((user) => user?.userid === userInfo?.userid)
              ?.menulist
          );
        }
        saveRoleList(roleList);
        updateUserList(userList);
      }
    }
  };

  const onFinish = async () => {
    setLoader(true);
    const roleName = form.getFieldValue("rolename");
    const { code } = await CALL_API(
      `owner-roles/${clientId}/${details.roleId}`,
      "patch",
      {
        rolename: roleName,
        department: details.department || [],
        location: details?.locationId || [],
        menuList: details.menuList,
        rolestatus: details?.roleStatus,
        statusId: details?.statusId,
      }
    );
    if (STATUS_CODE.SUCCESS === code) {
      fetchMasterData(true, menuList, userInfo?.userRoleType);
      getRoleList();

      setSuccessModal(true);
      setSuccessMessage("Saved");
      setTimeout(() => {
        setSuccessModal(false);
        setSuccessMessage("");
        setIsEditRole(false);
      }, 3000);
    }
    setLoader(false);
  };

  const footerStyle = {
    position: "absolute",
    bottom: -40,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  return (
    <EditRoleWrapp>
      <label
        className="bg-transparent border-0 mb-3 text-left styled-cursor"
        onClick={() => setIsEditRole(false)}
      >
        Role - Permission <ArrowForwardIosIcon className="px-1" />
      </label>{" "}
      <b className="pb-0 pt-1">Editing Role</b>
      <Form
        form={form}
        name="addrole"
        layout="vertical"
        initialValues={{ rolename: details?.roleName }}
        onFinish={(values) => {
          onFinish();
        }}
      >
        <Row gutter={12}>
          <Col xs={24} sm={24} ref={containerRef}>
            <Form.Item
              label="Role"
              name="rolename"
              rules={[
                {
                  required: true,
                  message: "Role name is required",
                },
                {
                  validator: (_, value) => {
                    if (typeof value === "string" && value.trim()) {
                      const trimmedValue = value.trim();
                      if (
                        details?.roleName !== trimmedValue &&
                        roleList.some((data) => data.roleName === trimmedValue)
                      ) {
                        return Promise.reject(
                          new Error("Role Name already exists")
                        );
                      }
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                maxLength={20}
                placeholder="Role Name"
                onKeyDown={(e) => {
                  const allowedChars = /^[a-zA-Z\s]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <div style={footerStyle}>
          <ButtonOutlined onClick={() => setIsEditRole(false)}>
            Cancel
          </ButtonOutlined>
          <ButtonFilled loading={loader} type="primary" htmlType="submit">
            Save Changes
          </ButtonFilled>
        </div>
      </Form>
      <SuccessPopup
        open={successModal}
        close={setSuccessModal}
        text={successMessage}
      />
    </EditRoleWrapp>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUserList: setUserList,
      saveRoleList: setRoleList,
      saveMenuList: setMenuList,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps, null)(EditRole);
